'use client';

import { useState } from 'react';
import { SearchCompanyItem } from '@/apiTypes/types';
import { SearchV3Scope } from '@/lib/enums/searchScope';
import { loadSearch } from '@/lib/dataProviders/search/loadSearch';

interface IUseCompanySearchOptions {
  onlyRegisteredCompanies?: boolean;
}

const useCompanySearch = ({ onlyRegisteredCompanies }: IUseCompanySearchOptions = {}) => {
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState<SearchCompanyItem[]>([]);

  const getCompanies = async (q: string) => {
    setLoading(true);
    try {
      const result = await loadSearch(
        {
          query: q,
          scope: SearchV3Scope.companies,
          onlyRegisteredCompanies,
        },
        {
          from: 0,
          limit: 10,
        },
      );
      if (result.items.length) {
        setResults(result.items);
      }
    } catch (e) {
      console.error('company search failed', e);
    } finally {
      setLoading(false);
    }
  };

  const search = (q: string) => {
    if (q) {
      void getCompanies(q);
    } else {
      setResults([]);
    }
  };

  const clearResults = () => {
    setResults([]);
  };

  return {
    loading,
    results,
    search,
    clearResults,
  };
};

export default useCompanySearch;
